import React from 'react';
import { ReactComponent as RectangleSVG } from '../../assets/images/icons/rectangle.svg';

export default function Rectangle(props) {
  const { theme } = props;

  return (
    <RectangleSVG {...props} fill={theme.colors.consolidationComebackWrapper} className={'icon'} />
  );
}
